import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type LanguageType = 'en' | 'fr'

interface State {
  language: LanguageType
}

export const initialState: State = {
  language: 'en',
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLanguage: (state, { payload }: PayloadAction<LanguageType>) => {
      state.language = payload
    },
  },
})

export const { setLanguage } = appSlice.actions
export default appSlice.reducer
